//  @/store/modules/leasing.js
import Vue from 'vue'

const state = {
    headers: [
        {
            text: 'Fournisseur',
            value: 'vendor',
        },
        {
            text: 'Facteur',
            value: 'factor',
        },
        {
            text: 'Tranche',
            value: 'range',
        },
        {
            text: 'Fréquence',
            value: 'freq',
        },
        {
            text: 'Périodes',
            value: 'periods',
        },
        {
            text: 'Valeur résiduelle',
            value: 'buyout',
        },
    ],
    items: [],
  }
  
  const mutations = {
    SET_LISTENER (state, listener) {
      state.listener = listener
    },
    SET_ITEM (state, doc) {
      const data = doc.data()
      state.items = {
        ...state.items, 
        [doc.id]: data
      }
    },
    UPDATE_ITEM (state, doc) {
      state.items[doc.id] = doc.data()
    },
    DELETE_ITEM (state, doc) {
      Vue.delete(state.items, doc.id)
    },
  }

  const getters = {}
  
  const actions = {
    async init({ commit, state, rootState }) {
      commit('SET_LISTENER', 
      rootState.db.collection('leasing').onSnapshot(snapshot => {
        let changes = snapshot.docChanges()
        changes.forEach(change => {
          let type = change.type
          let doc = change.doc
          
          if(type === 'added') commit('SET_ITEM', doc)
          else if(type === 'modified') commit('UPDATE_ITEM', doc)
          else if(type === 'removed') commit('DELETE_ITEM', doc)
        })
      }, (error) => {console.log(error.message)}))
    },
    async add({ rootState }, data) {
      let update = {
        time: new Date().toISOString(),
        user: rootState.auth.user.id,
        action: 'created',
      }

      data.updates = [ update ]

      let response = await rootState.db.collection('leasing').add(data)
      return response
    },
    async set({ rootState }, data) {
      let update = {
        time: new Date().toISOString(),
        user: rootState.auth.user.id,
        action: 'created',
      }

      data[1].updates = [ ...data[1].updates, update ]

      let ref = rootState.db.collection('leasing').doc(data[0])
      let response = await ref.set(data[1])
      return response
    },
    async delete({ rootState }, id) {
      let response = await rootState.db.collection('leasing').doc(id).delete()
      return response
    },
    async close({ rootState }) { 
      let response = await rootState.db.collection('leasing').onSnapshot(() => {})
      return response
    },
  }
  
  export default { 
    namespaced: true, state, mutations, getters, actions
  }